<template>
  <div
    :class="['custom-select__wrapper', {'custom-select__wrapper_autoHeight': !!this.autoHeight}]"
  >
    <div v-if="this.label" class="custom-select__label">
      {{ label

      }}<span
        v-if="required"
        style="color: red;"
        >{{ required ? '*' : '' }}</span
      >
    </div>
    <q-select
      :class="['custom-select', {'custom-select__hideInput': this.hideInputOnSelect !== false && !!this.value && !this.multiple, 'custom-select__white': !!this.whiteMode, 'custom-select__autoHeight': !!this.autoHeight, 'custom-select__fullWidth': !!this.fullWidth}]"
      :options="filteredOptions"
      v-model="model"
      :display-value="displayValue"
      :placeholder="`${this.placeholder || 'Выберите..'} `"
      :use-input="this.useInput !== false"
      :dense="true"
      :map-options="true"
      ref="select"
      :outlined="true"
      :multiple="this.multiple"
      :hide-bottom-space="this.hideBottomSpace === undefined || this.hideBottomSpace === true"
      :options-dense="true"
      :loading="this.loading"
      :option-value="this.optionValueKey"
      :option-label="this.optionLabelKey || ''"
      dropdown-icon="img:/img/icons/arrow_down.svg"
      @filter="filterFn"
      :rules="this.rules"
      :disable="this.disabled"
    >
      <template
        v-slot:selected
        v-if="this.multiple && (this.computedOptions?.length - 1) === this.value?.length"
      >
        <div v-if="this.value?.length">Все</div>
      </template>
      <template v-slot:selected v-if="this.colorMode">
        <span
          :style="this.selectedItem?.style || {}"
          style="min-height: 15px; width: 100%; border-radius: 4px;"
          >{{ this.selectedItem?.label }}</span
        >
      </template>
      <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
        <q-item
          v-if="!opt.isDivider"
          v-bind="itemProps"
          :style="opt.style || {}"
        >
          <q-item-section avatar v-if="this.iconKey && opt[this.iconKey]">
            <i class="fa" :class="opt[this.iconKey]"></i>
          </q-item-section>
          <q-item-section>
            <q-item-label
              :style="{ 
                fontSize: '13px',
                color: opt[this.textColor] || 'inherit', 
                fontWeight: opt.bold || opt.level === 1 ? 'bold' : 'normal',  
                paddingLeft: opt.level > 1 ? `${(opt.level - 1) * 10}px` : '0px' 
              }"
              v-html="opt.label"
            />
          </q-item-section>
          <q-item-section side v-if="this.multiple">
            <q-checkbox
              :model-value="opt[this.optionValueKey] === 'ALL' ? (this.computedOptions?.length - 1) === this.value?.length : selected"
              @update:model-value="toggleOption(opt)"
            />
          </q-item-section>
        </q-item>
        <q-separator v-else class="divider" />
      </template>
      <template v-slot:no-option>
        <q-item>
          <q-item-section
            class="text-grey"
            >{{this.noOptionText || 'Не найдено'}}</q-item-section
          >
        </q-item>
      </template>
      <template v-slot:default v-if="!!this.title">
        <q-tooltip>{{this.title}}</q-tooltip>
      </template>
      <template v-if="value" v-slot:append>
        <q-icon
          name="cancel"
          v-if="(this.multiple ? !!this.value?.length : !!value) && this.clearable !== false"
          @click.stop.prevent="onChange(this.multiple ? [] : '')"
          class="cursor-pointer custom-select__icon"
        />
      </template>
    </q-select>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  props: [
    "options",
    "value",
    "onChange",
    "useInput",
    "hideInputOnSelect",
    "label",
    "placeholder",
    "required",
    "triggerValidationOnMount",
    "multiple",
    "colorMode",
    "loading",
    "optionLabelKey",
    "optionValueKey",
    "filterFunc",
    "fullWidth",
    "clearable",
    "title",
    "noOptionText",
    "iconKey",
    "textColor",
    "level",
    "hideBottomSpace",
    "whiteMode",
    "autoHeight",
    "disabled",
  ],
  data() {
    return {
      searchTerm: "",
    };
  },
  mounted() {
    if (this.triggerValidationOnMount)
      this.$refs.select.validate()
  },
  computed: {
    model: {
      get() {
        // Для не-multiple: если value - это ID, нужно найти соответствующий объект в опциях
        // Quasar с map-options="true" ожидает объект из опций
        if (!this.multiple) {
          // Для булевых значений false нужно обрабатывать отдельно, так как false == null даст false
          if (this.value === null || this.value === undefined || this.value === '') {
            return null;
          }
          // Ищем объект в опциях по ID (с учетом разных типов)
          const foundOption = this.computedOptions?.find(
            item => {
              const itemValue = item[this.optionValueKey];
              // Сравниваем с учетом типов (строка/число/булево)
              // Для булевых значений используем строгое сравнение
              if (typeof itemValue === 'boolean' || typeof this.value === 'boolean') {
                return itemValue === this.value;
              }
              // Для остальных типов используем нестрогое сравнение или сравнение строк
              return itemValue == this.value || String(itemValue) === String(this.value);
            }
          );
          return foundOption || null;
        }
        return this.value;
      },
      set(row) {
        let value;
        if (this.multiple) {
          if (row?.length) {
            let newValue = row[row?.length - 1][this.optionValueKey]
            if (newValue === 'ALL') {
              const checked = row?.length === this.computedOptions?.length
              if (checked)
                value = []
              else
                value = this.computedOptions?.map(item => item[this.optionValueKey])?.filter(item => item !== 'ALL')
            } else
              value = row?.map(item => typeof item === 'object' ? item[this.optionValueKey] : item)
          } else
            value = []
        } else {
          // Для не-multiple: с map-options="true" Quasar всегда передает объект из опций
          if (row && typeof row === 'object' && !Array.isArray(row)) {
            // Извлекаем ID из объекта
            // Используем проверку на undefined/null, чтобы не потерять false и 0
            const extractedValue = row[this.optionValueKey];
            value = extractedValue !== undefined && extractedValue !== null ? extractedValue : null;
          } else {
            value = null;
          }
        }
        this.$emit("change", value, row);
      },
    },
    computedOptions() {
      // Убеждаемся, что options - это массив
      if (!Array.isArray(this.options)) {
        return [];
      }
      let options = this.options.map(item => ({
        ...item,
        label: item[this.optionLabelKey] || item[this.optionValueKey] || ''
      }));
      if (this.multiple && options)
        options = [{label: "Выбрать все", [this.optionLabelKey]: 'Все', [this.optionValueKey]: 'ALL'}, ...options]
      return options
    },
    selectedItem() {
      return this.computedOptions?.find(item => {
        const itemValue = item[this.optionValueKey];
        // Для булевых значений используем строгое сравнение
        if (typeof itemValue === 'boolean' || typeof this.value === 'boolean') {
          return itemValue === this.value;
        }
        return itemValue === this.value;
      });
    },
    filteredOptions() {
      if (!this.searchTerm) return this.computedOptions
      const searchLower = this.searchTerm?.toLowerCase()
      return this.computedOptions?.filter((item) => {
        const label = item[this.optionLabelKey]?.toLowerCase() || ''
        // Ищем по label (который уже содержит ID / название)
        if (label.includes(searchLower)) return true
        // Также ищем по ID, если он есть в данных
        const idValue = item[this.optionValueKey]
        if (idValue && idValue.toString().toLowerCase().includes(searchLower)) return true
        return false
      });
    },
    rules() {
      const rules = []
      // Не применяем правила валидации для disabled полей
      if (this.required && !this.disabled) {
        const reqFunc = val => (!!val) || 'Это поле обязательно'
        rules.push(reqFunc)
      }
      return rules
    },
    displayValue() {
      const noOptions = !this.computedOptions || this.computedOptions.length === 0
      if (noOptions) {
        if (this.multiple) {
          if (Array.isArray(this.value) && this.value.length) return ''
        } else if (this.value) {
          return ''
        }
      }
      return undefined
    },
  },
  methods: {
    filterFn(val, update) {
      update(() => {
        this.searchTerm = val;
      });
      if (!!this.filterFunc) {
        this.filterFunc(val, update)
      }
    },
  },
};
</script>

<style lang="scss">
.custom-select {
  font-size: 14px;
  padding-bottom: 0 !important;

  &__wrapper {
    &_autoHeight {
      height: inherit;
    }
  }

  & .q-field__input::placeholder {
    color: #9CA3AF;
    font-size: 12px;
  }

  &__hideInput .q-field__input {
    display: none !important;
  }

  & .q-field__native span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 13px;
  }
  & .q-select__dropdown-icon img {
    width: 10px;
  }

  & .q-field__bottom {
    padding-top: 4px !important;
    padding-left: 0 !important;
    font-size: 12px !important;
  }

  & .q-field__control {
    &::before {
      border: 1px solid #D1D5DB !important;
      border-radius: 8px !important;
    }
    &::after {
      border-radius: 8px !important;
    }
  }

  &__white {
    & .q-field__control {
      &::before {
        background-color: #fff;
      }
    }
  }

  &__autoHeight {
    height: inherit;
    & .q-field__control,
    & .q-field__inner {
      height: inherit !important;
    }

    & .q-field__control,
    & .q-field__native {
      min-height: auto !important;
    }

    & .q-field__marginal {
      min-height: auto !important;
      height: auto !important;
    }
  }

  &__icon {
    font-size: 19px !important;
  }

  &__fullWidth {
    width: 100%;
  }

  &__label {
    font-size: 13px;
    line-height: 13px;
    margin-bottom: 8px;
    color: #1d1d1d;
  }

  // Убираем красную иконку ошибки для disabled полей
  &.q-field--disabled {
    .q-field__messages {
      display: none !important;
    }

    .q-field__append {
      .q-field__messages {
        display: none !important;
      }

      // Скрываем красную иконку ошибки в append
      .q-icon {
        display: none !important;
      }
    }

    // Скрываем красную иконку в marginal слоте
    .q-field__marginal {
      .q-icon {
        color: transparent !important;
        display: none !important;
      }
    }

    .q-field__label {
      color: #1d1d1d !important;
      opacity: 1 !important;
    }

    // Убираем красную рамку при hover для disabled полей
    .q-field__control::before {
      border-color: #D1D5DB !important;
    }

    // Убираем красную иконку ошибки
    .q-field__bottom {
      display: none !important;
    }

    // Убираем красную иконку при hover
    &:hover .q-field__append .q-icon,
    &:hover .q-field__marginal .q-icon {
      display: none !important;
      color: transparent !important;
    }
  }
}

// Стили для label вне disabled состояния
.custom-select__wrapper {
  .custom-select__label {
    color: #1d1d1d !important;
  }
}

.q-menu.q-position-engine {
  margin-top: 6px !important;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.25) !important;
  border-radius: 8px !important;
}

.divider {
  margin: 9px 0 !important;
}
</style>
